'use client'

import { AccountMenu } from './header-account-menu'
import { useAccount } from '@dustin-web/product-components/src/hooks/dataloader/use-account'
import { AccountMenuLogin } from './header-account-menu-login-abtest'
import { AccountMenuRegister } from './header-account-menu-register-abtest'
import { useAuth } from '@dustin-web/microsite-components/src/auth'
import { Skeleton } from '@dustin-web/microsite-components/src/skeleton'

const AccountMenuContainer = () => {
  const { customerNavigationData, contactQueryData, contactQueryError } = useAccount()
  const { isAuthenticated, isLoading } = useAuth()

  if (isAuthenticated && contactQueryError) {
    // temp fix: handle case where auth headers are expired
    return (
      <>
        <AccountMenuLogin />
        <AccountMenuRegister />
      </>
    )
  }
  return (
    <>
      {isLoading ? (
        <div className="u-pt-8 u-pr-32">
          <Skeleton shade={'light-on-dark-bg'} width={178} height={40}></Skeleton>
        </div>
      ) : (
        <>
          {!isAuthenticated ? (
            <>
              <AccountMenuLogin
                contactQueryData={contactQueryData}
                contactQueryError={contactQueryError}
              />
              <AccountMenuRegister
                contactQueryData={contactQueryData}
                contactQueryError={contactQueryError}
              />
            </>
          ) : (
            <AccountMenu
              customerNavigationData={customerNavigationData}
              contactQueryData={contactQueryData}
              contactQueryError={contactQueryError}
            />
          )}
        </>
      )}
    </>
  )
}
export default AccountMenuContainer
